@if (!dataHref) {
  <img
    product-image
    [product]="item"
    [size]="size"
    (click)="openDialog()"
    class="card-img-top img-responsive {{dataClasses}}"
    >
} @else {
  <a [routerLink]="[dataHref]">
    @if (!noImgCalc) {
      <img
        product-image
        [product]="item"
        [size]="size"
        no-image
        class="card-img-top img-responsive {{dataClasses}}"
        >
    }
    @if (imagePopularUrl) {
      <img [src]="imagePopularUrl"
        class="card-img-top img-responsive popular"
        alt="{{'Popular Image ' + popular |translate}}">
    }
    @if (noImgCalc) {
      <img [src]="productPic"
        class="card-img-top img-responsive {{dataClasses}}">
    }
  </a>
}
<ng-template #dialogTmp>
  <div class="image-dialog text-center modal-body">
    <button mat-dialog-close type="button" class="close close-modal" aria-label="{{'Close Dialog'|translate}}">×</button>
    <img product-image
      [product]="item"
      [size]="size"
      class="card-img-top img-responsive {{dataClasses}}"
      >
  </div>
</ng-template>
